import { restApiClient } from '@/datasources';
import { EditDependentForm } from '@/app/(main)/(pages)/(auth)/dependentes/_components/dependent-form.component';
import { Contact, Dependent } from '@/types/auth-base.types';

type EditDependentRequestDTO = EditDependentForm & {
  contact: Contact;
};

export async function updateDependent(dependentId: string, formData: Partial<EditDependentRequestDTO>) {
  const { data: createDependentResponse } = await restApiClient.put<Dependent>(
    `/online/customers/dependents/${dependentId}`,
    formData,
  );
  return createDependentResponse;
}
